import { render } from "./RoleComponent.vue?vue&type=template&id=75bda83f"
import script from "./RoleComponent.vue?vue&type=script&lang=js"
export * from "./RoleComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/settings/Role/RoleComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "75bda83f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('75bda83f', __exports__)) {
    api.reload('75bda83f', __exports__)
  }
  
  module.hot.accept("./RoleComponent.vue?vue&type=template&id=75bda83f", () => {
    api.rerender('75bda83f', render)
  })

}


export default __exports__